export const configElevationDh = {
  "Controller": {
    "Name": "Elevation"
  },
  "Source": {
    "data": {
      "Type": "TMS",
      "_url": "%expo_map_url%/numerical_tile/SRTM_ETOPO_EQDIST/%z%_%y%_%x%.png",
      "url": "%expo_map_url%/numerical_tile/NASA_SRTM_EQDIST/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 8,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 11,
        "YCoordinate": -1,
        "Projection": "EQR",
        "BoundingBox": {
          "West": -180,
          "South": -90,
          "East": 180,
          "North": 90
        }
      }
    }
  }
};

export const configTerrainElevationsDh = {
  "Source": {
    "region": {
      "Type":"JSON",
      "url": "pri/data/AeronauticalChart/region_terrain_elevations.json",
      "cache": true,
      "retain": true
    },
    "data": {
      "Type": "Text",
      "Name": "Maximum Terrain Elevations",
      "url": "pri/data/AeronauticalChart/maximum_terrain_elevations.csv",
      "cache": true,
      "retain": true
    }
  }
};
